export const BANKGIRO = 'bankgiro'
export const PLUSGIRO = 'postgiro'
export const BANK_ACCOUNT = 'bankaccount'
